import { ServerProjectInfo } from '@modules/auth/components/types/project';

import * as actionTypes from '../../constants/actionTypes';

export interface ISetProject {
  type: actionTypes.SET_PROJECT;
  project: ServerProjectInfo;
}

export const setProject = (project: ServerProjectInfo): ISetProject => ({
  type: actionTypes.SET_PROJECT,
  project,
});
